import { IMessagesToCustomerResponse } from "@portal/types/api/mailbox/IMessagesToCustomerResponse";
import useSWR, { SWRResponse } from "swr";
import { IUseTotalUnreadMessages } from "./types";
import { commonFetcher } from "../common/commonFetcher";

const useTotalUnreadMessages: IUseTotalUnreadMessages = (revalidate = false) => {
  const { data, error, isLoading }: SWRResponse<IMessagesToCustomerResponse, unknown> = useSWR(
    `/api/mailbox/toMessages?limit=1&offset=0`,
    commonFetcher<IMessagesToCustomerResponse>,
    {
      revalidateIfStale: revalidate,
      revalidateOnFocus: revalidate,
      revalidateOnReconnect: revalidate,
    },
  );

  return {
    data,
    isLoading,
    error,
  };
};

export default useTotalUnreadMessages;
